// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: games/quizzes/quizzes.proto

/* eslint-disable */
import type { FileAttachment } from "../../common/attachment";
import type { Channel } from "../../common/common";
import type { Game } from "../game";

export const QuizStatus = {
  UNKNOWN: "UNKNOWN",
  WAITING_FOR_PLAYERS: "WAITING_FOR_PLAYERS",
  SHOW_QUESTION: "SHOW_QUESTION",
  ANSWER_QUESTION: "ANSWER_QUESTION",
  QUESTION_RESULT: "QUESTION_RESULT",
  QUESTION_LEADERBOARD: "QUESTION_LEADERBOARD",
  GAME_RESULT: "GAME_RESULT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type QuizStatus = typeof QuizStatus[keyof typeof QuizStatus];

export namespace QuizStatus {
  export type UNKNOWN = typeof QuizStatus.UNKNOWN;
  export type WAITING_FOR_PLAYERS = typeof QuizStatus.WAITING_FOR_PLAYERS;
  export type SHOW_QUESTION = typeof QuizStatus.SHOW_QUESTION;
  export type ANSWER_QUESTION = typeof QuizStatus.ANSWER_QUESTION;
  export type QUESTION_RESULT = typeof QuizStatus.QUESTION_RESULT;
  export type QUESTION_LEADERBOARD = typeof QuizStatus.QUESTION_LEADERBOARD;
  export type GAME_RESULT = typeof QuizStatus.GAME_RESULT;
  export type UNRECOGNIZED = typeof QuizStatus.UNRECOGNIZED;
}

export interface GameState {
  game: Game | undefined;
  status: QuizStatus;
  quiz: Quiz | undefined;
  currentQuestion?: Question | undefined;
  currentQuestionIndex: number;
}

export interface ClientCommand {
  /** / Sent by a user to create a new game. */
  createGame?:
    | CreateGameCommand
    | undefined;
  /** / A command sent by the host that allowes them to move to the next phase of the game, or end the game or go back to the lobby. */
  hostCommand?:
    | HostCommand
    | undefined;
  /** / Sent by the host to add questions to the game, while playing. */
  addQuestions?:
    | AddQuestionsCommand
    | undefined;
  /** Player Commands */
  answerQuestion?: AnswerQuestionCommand | undefined;
}

export interface CreateGameCommand {
  /** / The websocket channel that the game is being played on. */
  channel:
    | Channel
    | undefined;
  /** / The quiz that is being played. Contains alls the questions */
  quiz: Quiz | undefined;
}

export interface HostCommand {
  gameId: string;
  command: HostCommand_StatusCommand;
}

export const HostCommand_StatusCommand = {
  UNKNOWN: "UNKNOWN",
  /** NEXT - / Move to the next phase of the game. */
  NEXT: "NEXT",
  /** END_GAME - / End the game immediately, skip results screen and destroy the session. */
  END_GAME: "END_GAME",
  /** GO_BACK_TO_LOBBY - / Go back to the lobby, allowing more players to join while the current game is running. Does not reset the leaderboard. */
  GO_BACK_TO_LOBBY: "GO_BACK_TO_LOBBY",
  /** SKIP_TO_END_RESULTS - / Skip the questions and go straight to the end state of the game. Shows the leaderboard. */
  SKIP_TO_END_RESULTS: "SKIP_TO_END_RESULTS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type HostCommand_StatusCommand = typeof HostCommand_StatusCommand[keyof typeof HostCommand_StatusCommand];

export namespace HostCommand_StatusCommand {
  export type UNKNOWN = typeof HostCommand_StatusCommand.UNKNOWN;
  export type NEXT = typeof HostCommand_StatusCommand.NEXT;
  export type END_GAME = typeof HostCommand_StatusCommand.END_GAME;
  export type GO_BACK_TO_LOBBY = typeof HostCommand_StatusCommand.GO_BACK_TO_LOBBY;
  export type SKIP_TO_END_RESULTS = typeof HostCommand_StatusCommand.SKIP_TO_END_RESULTS;
  export type UNRECOGNIZED = typeof HostCommand_StatusCommand.UNRECOGNIZED;
}

/** / Sent by a player to answer a question. */
export interface AnswerQuestionCommand {
  gameId: string;
  answer: IndividualAnswer | undefined;
}

/** / Allows the host to add questions to a running game. */
export interface AddQuestionsCommand {
  gameId: string;
  questions: Question[];
}

/** / This is sent to create the game and configure the game settings. */
export interface Quiz {
  id: string;
  title: string;
  description?:
    | string
    | undefined;
  /** / The full list of questions and answers for the quiz. May be empty if this model is returned for playing users. */
  questions: Question[];
  totalQuestionCount?:
    | number
    | undefined;
  /** / The amount of time players have to answer each question. */
  answerDuration:
    | string
    | undefined;
  /** / The amount of time to show the question to the players before they can answer */
  questionShowDuration:
    | string
    | undefined;
  /** / Whether the answer duration is applied to the question. If false, there will be an infinite amount of time to answer the question. */
  isAnswerDurationApplied: boolean;
}

export interface Question {
  id: string;
  text: string;
  attachments: FileAttachment[];
  /** / Whether the question has a correct answer. Set to false for polls / votes / open ended questions. */
  hasCorrectAnswer: boolean;
  /** / Whether the answer has been revealed to the players. */
  isAnswerRevealed: boolean;
  /** / Reveal the aggregate results for the question. */
  aggregateResult?:
    | QuestionAggregateResult
    | undefined;
  /** / The answer submitted by the current user. */
  currentUserAnswer?:
    | IndividualAnswer
    | undefined;
  /** NumberQuestion number = 11; */
  multipleChoice?: MultipleChoiceQuestion | undefined;
}

export interface MultipleChoiceQuestion {
  answers: MultipleChoiceAnswer[];
}

/** / A single answer for a multiple choice question. */
export interface MultipleChoiceAnswer {
  id: string;
  text: string;
  attachments: FileAttachment[];
  isCorrect?: boolean | undefined;
}

/** / The aggregate results for a question. Show on the host screen */
export interface QuestionAggregateResult {
  questionId: string;
  totalAnswers: number;
  multipleChoice?: MultipleChoiceAggregateResult | undefined;
}

/** / The aggregate results for a multiple choice question. Counts the number of times each answer was selected. */
export interface MultipleChoiceAggregateResult {
  answerCounts: { [key: string]: number };
}

export interface MultipleChoiceAggregateResult_AnswerCountsEntry {
  key: string;
  value: number;
}

/** / A unique answer submitted by a player. */
export interface IndividualAnswer {
  questionId: string;
  /** int64 number_answer = 3; // Add this back in if we want to support number questions. */
  multipleChoiceAnswerId?: string | undefined;
}
